
import React from 'react';

import Badge from '../Badge/index.jsx';
import NotificationImage from '../NotificationImage/index.jsx';


class AssetResearch extends React.Component {
  render() {
    return (
      <div className="cs-asset-research">
        {this.props.children}
      </div>
    );
  }
}


class List extends React.Component {
  render() {
    var content = [];

    if (this.props.articles && this.props.articles.length) {
      for (var i = 0; i < this.props.articles.length; i++) {
        var article = this.props.articles[i];

        content.push(
          <a key={article.id} href={article.permalink} className="cs-asset-research__item">
            <div className="cs-asset-research__image">
              <NotificationImage image={article.image} />
            </div>
            <p className="cs-asset-research__description">
              <span dangerouslySetInnerHTML={{__html: article.title}} /><br />
              <Badge variant="light">{article.type}</Badge><br />
              <span className="has-grey-600-color">{article.age} ago.</span> <strong className="has-brand-orange-color">Read More</strong>
            </p>
          </a>
        );
      }
    }


    return content;
  }
}


AssetResearch.List = List;


export default AssetResearch;

